import React from "react";

export const ExternalLink = ({
  href,
  children,
}: {
  href: string;
  children: React.ReactNode;
}) => (
  <a
    href={href}
    target="_blank"
    rel="noreferrer"
    className="underline decoration-white/20 hover:decoration-white/40 transition-colors [overflow-wrap:anywhere]"
  >
    {children}
  </a>
);

export const GuideBullets = ({
  items,
  className = "",
}: {
  items: React.ReactNode[];
  className?: string;
}) => (
  <ul
    className={`list-disc pl-5 space-y-1 text-white/70 text-[14px] font-normal leading-[140%] ${className}`}
  >
    {items.map((item, idx) => (
      <li key={idx} className="pl-1">
        {item}
      </li>
    ))}
  </ul>
);

export const GuideOrderedList = ({
  items,
  className = "",
}: {
  items: React.ReactNode[];
  className?: string;
}) => (
  <ol
    className={`list-decimal pl-5 space-y-1 text-white/70 text-[14px] font-normal leading-[140%] ${className}`}
  >
    {items.map((item, idx) => (
      <li key={idx} className="pl-1">
        {item}
      </li>
    ))}
  </ol>
);

export const GuideCard = ({
  title,
  children,
  footerRight,
  containerClassName = "w-full rounded-[20px] lg:p-[24px]",
  titleClassName = "font-medium text-white text-[18px] leading-[24px]",
  bodyClassName = "mt-3 text-white/70 text-[14px] font-normal leading-[140%]",
  footerClassName = "mt-4 flex items-center justify-end text-white/50 text-[14px] leading-[16px]",
}: {
  title: string;
  children: React.ReactNode;
  footerRight?: React.ReactNode;
  containerClassName?: string;
  titleClassName?: string;
  bodyClassName?: string;
  footerClassName?: string;
}) => (
  <div className={containerClassName}>
    <p className={titleClassName}>{title}</p>
    <div className={bodyClassName}>{children}</div>
    {footerRight && <div className={footerClassName}>{footerRight}</div>}
  </div>
);

